import React, { useRef, useState } from "react";
import axios from "axios";
import { ROOT_URL } from "../../../config/url";
import {
  getErrorMessageByKey,
  Textarea,
  useNotification,
  Modal,
  useObject,
  jsonFormatText,
  isValidateNullText, Input, Select,
} from "@vokymlak/kabinet-ui";
import moment from "moment";

function ModalSiteShopOrderEditAction(props) {
  const [selectStage, setSelectStage] = useState(null);

  const {
    object: [object],
  } = useObject({
    apiUrl: "/api/site-shop-order/" + props.object.uuid,
    rootUrl: ROOT_URL,
    callbackResponse: (data) => {
      setSelectStage((!!data && !!data.site_shop_order_status_type && data.site_shop_order_status_type.tag) || null);
    },
    callbackError: () => {
      props.handleClose();
    },
  });


  const selectOrderStageType = useRef(null);
  const selectOrderStatusType = useRef(null);

  const { notification } = useNotification();

  const changeEdit = (event) => {
    event.preventDefault();

    let orderStageType = selectOrderStageType.current.value;
    orderStageType = orderStageType.length > 0
      ? orderStageType === "null"
        ? null
        : orderStageType
      : null

    let orderStatusType = null;

    if (!!selectStage && selectStage === 'AT_WORK') {
      orderStatusType = selectOrderStatusType.current.value;
      orderStatusType = orderStatusType.length > 0
        ? orderStatusType === "null"
          ? null
          : orderStatusType
        : null
    }

    const jsonData = JSON.stringify({
      site_shop_order_status_type: !!orderStageType ? {
        tag: orderStageType,
      } : null,
    });

    axios
      .put("/api/site-shop-order/" + props.object.uuid + "/edit/action", jsonData, {
        withCredentials: false,
        baseURL: ROOT_URL,
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("tokenSession"),
        },
      })
      .then(() => {
        props.successfulRequest();
        notification("Данные сохранены", "green");
        props.handleClose();
      })
      .catch((error) => {
        notification(getErrorMessageByKey(error.response.data.error), "red");
      });
  };

  const changeStage = () => {
    let orderStageType = selectOrderStageType.current.value;
    orderStageType = orderStageType.length > 0
      ? orderStageType === "null"
        ? null
        : orderStageType
      : null
    setSelectStage(orderStageType)
  }

  return (
    !!object && (
      <Modal handleClose={() => props.handleClose()}>
        <form className="Form" onSubmit={(event) => changeEdit(event)}>
          <div
            className="Form__title"
            style={{ fontSize: 19, fontWeight: 700 }}
          >
            №{object.id}{!!object.date && ' от ' + moment(object.date.substring(0, 19)).format("DD.MM.YYYY HH:mm")}
            <div className="Text__signature">Заказ по рознице</div>
          </div>

          <div className={"Form__field " + (!!selectStage && selectStage !== 'AT_WORK' && "Form__field_last")}>
            <Select
              isFixed={true}
              reference={selectOrderStageType}
              options={[
                {
                  value: "NEW",
                  title: "Новый",
                },
                {
                  value: "CONFIRMATION",
                  title: "Подтверждение",
                },
                {
                  value: "COMPLETED",
                  title: "Оформлен",
                },
                {
                  value: "CANCELLED",
                  title: "Отменён",
                }
                ]}
              label="Статус"
              onChange={() => changeStage()}
              value={!!object.site_shop_order_status_type && object.site_shop_order_status_type.tag}
            />
          </div>

          <div className="Form__actions Form__actions_center">
            <button className="Action__button Action__button_all Action__button_blue">
              Применить
            </button>
          </div>

          {/*<div className="Form__actions Form__actions_center">*/}
          {/*  <div className="Action__link" onClick={() => props.handleClose()}>*/}
          {/*    Отмена*/}
          {/*  </div>*/}
          {/*</div>*/}
        </form>
      </Modal>
    )
  );
}

export default ModalSiteShopOrderEditAction;
